// this is an autogenerated file from DesignSystem/AppointmentActions/Unseat/Content/MissingRequiredTreatmentFieldsDialog/Content/TreatmentFields/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_AppointmentActions_Unseat_Content_MissingRequiredTreatmentFieldsDialog_Content_TreatmentFields($appointment_id: uuid!) {
  appointments_missing_required_treatment_fields(
    args: { _appointment_id: $appointment_id }
    order_by: { number: asc }
  ) {
    id
    name
  }
}

`